import type { DefaultValues, SubmitHandler } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { usePersistentForm } from '~/components/utils/PersistentForm';
import { useFormAutoFocus } from '~/hooks/useFormAutoFocus';
import { OrganizationFormIosSection } from './OrganizationFormIosSection';
import { OrganizationFormMainSection } from './OrganizationFormMainSection';

export type IOrganizationFormValues = {
  name: string;
  email: string;
  appleSetupDone?: boolean;
  appleTeamStatus?: 'valid' | 'unknown' | 'checking';
  appleSectionExpanded?: boolean;
  appleTeamId?: string;
};

export type IOrganizationFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<IOrganizationFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    mode: IFormMode;
    defaultValues?: DefaultValues<IOrganizationFormValues>;
    onSubmit?: SubmitHandler<IOrganizationFormValues>;
  };

export const OrganizationForm: React.FC<IOrganizationFormProps> = (props) => {
  const { sx, mode, defaultValues, onSubmit, ...other } = props;
  const form = usePersistentForm<IOrganizationFormValues>({
    defaultValues,
  });
  useFormAutoFocus({ form, name: 'name' });

  return (
    <ContentBlock.FormBody sx={sx} form={form} onSubmit={onSubmit} {...other}>
      <OrganizationFormMainSection form={form} mode={mode} />
      <OrganizationFormIosSection form={form} mode={mode} />
    </ContentBlock.FormBody>
  );
};
